import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import PriceLabel from '@components/PriceLabel';
import { useIsDualPrice } from '@containers/ProductDetailContainer/ProductDetail/hooks/useIsDualPrice';
import { AB_TEST_ORIGINAL_PRICE_DISCOUNT_PERCENTAGE_THRESHOLD } from '@containers/ProductDetailContainer/ProductDetail/hooks/usePriceLogic';
import { getDiscountPercentage } from '@containers/ProductDetailContainer/ProductDetail/hooks/usePriceLogic/utils';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { Line, LineWrapper } from '../../SelectedVariant/styled';

import { actionCardMessages } from './messages';
import {
  PictogramWrapper,
  ActionCardInfo,
  ActionCardWrapper,
  PriceDetails,
  Slash,
  CurrencyWrapper,
  DiscountAmountWrapper,
  ActionPriceDescription,
  TopIcon,
  Prices,
} from './styled';

export const ActionCard = () => {
  const { currentVariant } = useProductDetailContext();
  const { experiment_pd_action_percentage_from_rrp } = useFeatureFlags();

  const variantPrice = currentVariant.price;

  const {
    isDualPrice,
    getLeftSideFormattedPrice,
    leftSideCurrency,
    rightSideCurrency,
    getRightSidePrice,
  } = useIsDualPrice();

  const percentage = getDiscountPercentage(
    variantPrice.value ?? 0,
    currentVariant.originalPrice?.value ??
      currentVariant.recentMinPrice?.value ??
      0
  );

  return (
    <div>
      <ActionCardWrapper>
        <ActionCardInfo>
          <PriceDetails>
            <Prices>
              {isDualPrice && (
                <>
                  {getLeftSideFormattedPrice(variantPrice.value ?? 0)}{' '}
                  <CurrencyWrapper>{leftSideCurrency}</CurrencyWrapper>
                  <Slash>/</Slash>
                </>
              )}
              <PriceLabel
                price={{
                  value: isDualPrice
                    ? getRightSidePrice(variantPrice.value ?? 0)
                    : variantPrice.value ?? 0,
                }}
                currencySymbolOverride={
                  isDualPrice ? rightSideCurrency : undefined
                }
                wrapperComponent={DiscountAmountWrapper}
                currencyComponent={CurrencyWrapper}
              />
            </Prices>
            <ActionPriceDescription>
              <FormattedMessage
                {...actionCardMessages.actionPriceDescription}
              />
            </ActionPriceDescription>
          </PriceDetails>

          <PictogramWrapper>
            <TopIcon>
              {experiment_pd_action_percentage_from_rrp &&
              percentage >= AB_TEST_ORIGINAL_PRICE_DISCOUNT_PERCENTAGE_THRESHOLD
                ? `-${percentage}%`
                : 'Top!'}
            </TopIcon>
          </PictogramWrapper>
        </ActionCardInfo>
      </ActionCardWrapper>

      <LineWrapper>
        <Line />
      </LineWrapper>
    </div>
  );
};
